import { render, staticRenderFns } from "./PasswordResetAction.vue?vue&type=template&id=62b02505&"
import script from "./PasswordResetAction.vue?vue&type=script&lang=js&"
export * from "./PasswordResetAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports